import React, { useState } from 'react';
import CyberBadge from '../common/CyberBadge';
import { Building2, Plus, Eye, Home } from 'lucide-react';

export default function PropertiesView({ rooms = [], onSelectDrawer, onOpenCreateModal }) {
  const [activeTab, setActiveTab] = useState('all');

  const buildingRooms = rooms.filter(
    (r) => r.moduleType === 'building' || r.categoryType === 'flat' || r.categoryType === 'room_rent'
  );

  const displayProperties = buildingRooms.length > 0 ? buildingRooms : [
    {
      _id: 'prop-101',
      title: 'Royal Heights 2BHK Luxury Flat',
      city: 'Indore, MP',
      price: 15000,
      priceType: 'month',
      categoryType: 'flat',
      status: 'approved',
    },
    {
      _id: 'prop-102',
      title: 'Vijay Nagar Executive Studio Room',
      city: 'Indore, MP',
      price: 8500,
      priceType: 'month',
      categoryType: 'room_rent',
      status: 'approved',
    },
  ];

  return (
    <div className="animate-fade" style={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
      {/* Header Banner */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <h1 className="page-title" style={{ fontSize: '1.75rem', fontWeight: 900, color: 'var(--text-primary)', margin: 0, display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Building2 size={28} style={{ color: 'var(--neon-green)' }} /> Building Properties (Rent & Sale)
          </h1>
          <p style={{ fontSize: '0.88rem', color: 'var(--text-secondary)', marginTop: '4px' }}>
            Verified residential apartments, studio rooms, and commercial space listings.
          </p>
        </div>

        <button
          className="btn btn-green"
          style={{ padding: '10px 20px', borderRadius: '10px', fontSize: '0.88rem' }}
          onClick={() => onOpenCreateModal('building', 'flat')}
        >
          <Plus size={16} /> Add Property Listing
        </button>
      </div>

      {/* SLEEK HIGH-TECH LIST VIEW */}
      <div className="cyber-list-container">
        {displayProperties.map((item, idx) => (
          <div
            key={item._id}
            className="cyber-list-row list-row-animate"
            style={{ animationDelay: `${idx * 0.08}s` }}
          >
            {/* Left Info Column */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '10px',
                  background: 'rgba(0, 255, 135, 0.12)',
                  border: '1px solid rgba(0, 255, 135, 0.35)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 0 12px rgba(0, 255, 135, 0.2)',
                }}
              >
                <Home size={20} style={{ color: 'var(--neon-green)' }} />
              </div>
              <div>
                <div style={{ fontSize: '1.05rem', fontWeight: 800, color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  {item.title}
                  <CyberBadge status={item.status || 'approved'} />
                </div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span>📍 {item.city || 'Indore, MP'}</span>
                  <span>•</span>
                  <span className="badge badge-emerald" style={{ fontSize: '0.65rem' }}>
                    {item.categoryType ? item.categoryType.toUpperCase() : 'RESIDENTIAL'}
                  </span>
                </div>
              </div>
            </div>

            {/* Right Action Column */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: '1.15rem', fontWeight: 900, color: 'var(--neon-green)', fontFamily: 'var(--font-mono)' }}>
                  ₹{item.price.toLocaleString()} <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>/ {item.priceType || 'month'}</span>
                </div>
                <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: '2px' }}>Verified Listing</div>
              </div>

              <button
                className="btn btn-outline"
                style={{ padding: '8px 14px', fontSize: '0.8rem' }}
                onClick={() => onSelectDrawer(item, 'room')}
              >
                <Eye size={14} /> View Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
